export default function cloudinaryLoader(props) {
  const { src, width, height, quality, c_fill } = props
    const params = ['f_auto', c_fill ? 'c_fill' : 'c_limit', `w_${width}`, `q_${quality || 'auto'}`, height ? 'w_'+height : '']
    return `https://res.cloudinary.com/timj111/image/upload/${params.join(',')}/${src.replace('https://res.cloudinary.com/timj111/image/upload/', '')}`
  }